export const logActions = (store) => (next) => (action) => {
  if (action.type !== "SET_COORDINATES_USER_JOB") {
    // console.log("dispatch", action);
  }
  return next(action);
};
